// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"jq-z","imageAndVideoCount":"kq-z","imageAndVideoContainer":"lq-z","viewAllReviews":"mq-z"};